import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { routeTree } from './routeTree.gen';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from './lib/query-client';
import { useAuth, type AuthData } from './hooks/use-auth';

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: null as unknown as AuthData,
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const client = new QueryClient();

const elem = document.getElementById("root")!;

function RouterProviderWithContext() {
  const auth = useAuth();
  return (
    <RouterProvider
      router={router}
      context={{
        auth,
      }}
    />
  );
}

const app = (
  <StrictMode>
    <QueryClientProvider client={client}>
      <RouterProviderWithContext />
    </QueryClientProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
